var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFashionPill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.481,
    height: 57.48,
    viewBox: "0 0 57.481 57.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_358",
    "data-name": "\\uADF8\\uB8F9 358",
    transform: "translate(-1061.9 -1191.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_48",
    "data-name": "\\uADF8\\uB8F9 48",
    transform: "translate(1119.38 1191.156) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_2",
    "data-name": "\\uD0C0\\uC6D0 2",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#43434b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.74,
    cy: 28.74,
    rx: 28.74,
    ry: 28.74,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.74,
    cy: 28.74,
    rx: 28.24,
    ry: 28.24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_23",
    "data-name": "\\uC120 23",
    y2: 57.481,
    transform: "translate(28.74)",
    fill: "#fff",
    stroke: "#43434b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashionPill);
export default __webpack_public_path__ + "static/media/fashion_pill.e0f6258b481c927944ea279606fdade7.svg";
export { ForwardRef as ReactComponent };